(() => {
  const body = document.body;
  const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
  const hero = firstSection?.matches('[data-lc-hero][data-overlay-header="true"]')
    ? firstSection
    : firstSection?.querySelector('[data-lc-hero][data-overlay-header="true"]');

  if (hero) {
    body.classList.add('lc-header-overlay');
    const updateHeaderState = () => body.classList.toggle('lc-header-scrolled', window.scrollY > 16);
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  const stickyBar = document.querySelector('[data-lc-sticky-atc]');
  if (!stickyBar) return;

  const sectionId = stickyBar.dataset.sectionId;
  const mainForm = document.querySelector(`#product-form-${sectionId}`);
  const mainButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);
  const stickyInput = stickyBar.querySelector('input[name="id"]');
  const stickyButton = stickyBar.querySelector('button[name="add"]');
  const stickyLabel = stickyButton?.querySelector('span');

  if (!mainForm || !mainButton || !stickyInput || !stickyButton) return;

  const syncStickyForm = () => {
    const mainInput = mainForm.querySelector('input[name="id"]');
    const mainLabel = mainButton.querySelector('span');
    if (mainInput?.value) stickyInput.value = mainInput.value;
    stickyInput.disabled = mainInput?.disabled ?? true;
    stickyButton.disabled = mainButton.disabled;
    if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent.trim();
  };

  syncStickyForm();
  document.addEventListener('change', syncStickyForm);
  document.addEventListener('variant:change', syncStickyForm);

  const setStickyVisibility = (visible) => {
    stickyBar.classList.toggle('is-visible', visible);
    stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => setStickyVisibility(!entry.isIntersecting && entry.boundingClientRect.bottom < 0),
      { threshold: 0 }
    );
    observer.observe(mainButton);
  } else {
    const updateStickyVisibility = () => setStickyVisibility(mainButton.getBoundingClientRect().bottom < 0);
    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  }
})();
